import { Copy } from '../copy/Copy';

export const POST_INIT_VALUES = {
  content: '',
};

export const POST_MAX_CHARS = { maxLength: 500 };

export const DEFAULT_POST = {
  defaultId: 'DEFAULT',
  name: Copy.generate('Feed.defaultPost.name'),
  content: Copy.generate('Feed.defaultPost.content'),
};
